import { HttpClient, HttpStatusCode } from '@/data/protocols/http'
import { AccessDeniedError, BadRequestError, ForbiddenError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { CreditCardModel } from '@/domain/models'
import { DeleteCreditCard } from '@/domain/usecases'

export class RemoteDeleteCreditCard implements DeleteCreditCard {
  constructor (
    private readonly url: string,
    private readonly httpCliente: HttpClient<string>
  ) {}

  async delete (params: CreditCardModel): Promise<string> {
    const { statusCode, body } = await this.httpCliente.request({
      method: 'put',
      url: `${this.url}/api/portal/remover-dados-cartao/${params.codCliente}`
    })

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }
        return body
      case HttpStatusCode.badRequest: throw new BadRequestError(body)
      case HttpStatusCode.forbidden: throw new ForbiddenError(body)
      case HttpStatusCode.notFound: throw new ForbiddenError(body)
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
